import {createContext} from 'react';

export const AdminAccessContext = createContext({
  isAdminAccessMode: false,
  targetCompany: null,
  remainingTime: null,
  reason: null,
  isTransitioning: false,
  grantAccess: () => {},
  revokeAccess: () => {},
  checkStatus: () => {},
});
